import type { Account } from "../types/management-auth";

export const isRootAccount = (accountId: string | Account | undefined) => {
    if (typeof accountId === "string") {
        return accountId.endsWith("00000000");
    }
    if (
        typeof accountId === "object" &&
        "account_id" in accountId &&
        accountId.account_id
    ) {
        return accountId.account_id.endsWith("00000000");
    }
    return false;
};
